<template>
  <ul class="sns">

    <social-sharing
      :url="current_url"
      :title="title"
      :description="description"
      :quote="quote"
      :hashtags="hashtags"
      twitter-user="NACT_PR"
      inline-template>
      <div>
        <network network="twitter">
          <li class="item-sns"><a><span class="icon-twitter"></span></a></li>
        </network>
        <network network="facebook">
          <li class="item-sns"><a><span class="icon-facebook"></span></a></li>
        </network>
        <network network="line">
          <li class="item-sns"><a><span class="icon-line"></span></a></li>
        </network>
      </div>
    </social-sharing>
  </ul>
</template>

<script>
import SocialSharing from 'vue-social-sharing'

export default {
  props: {
    title: {
      type: String,
      default: function() {
        return '国立新美術館 建築ガイドアプリCONIC (コニック)'
      }
    },
    description: {
      type: String,
      default: function() {
        return '国立新美術館 建築ガイドアプリCONIC (コニック)'
      }
    },
    quote: {
      type: String,
      default: function() {
        return '国立新美術館 建築ガイドアプリCONIC (コニック)'
      }
    },
    hashtags: {
      type: String,
      default: function() {
        return '国立新美術館, 美術館, 建築, conic'
      }
    },
  },

  data() {
      return {
        current_url: window.location.href.split('?')[0]
      }
    },

  components: {
    SocialSharing
  }
}
</script>
